import { useLouiseSelector } from '../../../store/redux/store';
import { ToolbarItemStatus } from '../types/Sidebar';

interface UseRiskObjectOffersStatus {
  getStatus: (riskType: string) => ToolbarItemStatus | undefined;
}

const useRiskObjectOffersStatus = (): UseRiskObjectOffersStatus => {
  const visitedOverviewPages = useLouiseSelector(
    (state) => state.offers.visitedOverviewPages,
  );
  const selectedOffers = useLouiseSelector(
    (state) => state.offers.selectedOffers,
  );

  const getStatus = (riskType: string): ToolbarItemStatus | undefined => {
    // Check if offer of type {riskType} is in selected offers
    if (Object.keys(selectedOffers)?.includes(riskType)) {
      return 'CHECKED';
    }
    // Check if page has been visited
    if (visitedOverviewPages?.includes(riskType)) {
      return 'SKIPPED';
    }
    return;
  };

  return {
    getStatus,
  };
};

export default useRiskObjectOffersStatus;
